import Worker from "worker-loader!./worker";
import { createUuid } from "../functions";

export default class WorkerManager {
    /**
     * Webworker pool; default worker is a data storage handler
     * @module WorkerManager
     */
    constructor(){
        this.callbackPool = {};
        this.pool = {
            "__DEFAULT_WORKER": new Worker()
        };
        // Add worker callback handler
        this.pool.__DEFAULT_WORKER.onmessage = (event) => {
            if (event && event.data.id && this.callbackPool[event.data.id]) {
                // Do callback once, if applicable
                if (typeof this.callbackPool[event.data.id] === "function") {
                    this.callbackPool[event.data.id](event.data.data);
                }
                delete this.callbackPool[event.data.id];
            }
        };
    }

    /**
     * Wrap message into worker-readable format and post to worker
     * @param {string} topic Message topic
     * @param {Function} callback
     * @param {Object} data Data attachment to message
     * @param {string} workerID Worker ID in the pool
     */
    postMessage(topic, callback = null, data = null, workerID = "__DEFAULT_WORKER"){
        const id = createUuid();
        this.callbackPool[id] = callback;
        this.pool[workerID].postMessage({
            id: id,
            topic: topic,
            data: data
        });
    }
}